export default "__VITE_ASSET__070bd677__"